import React from "react";

const PGWallet = React.lazy(() => import('../pages/Authenticated/PGWallet'));
const MoneyTransfer = React.lazy(() => import('../pages/Authenticated/MoneyTransfer'));
const MudraRashi = React.lazy(() => import('../pages/Authenticated/MudraRashi'));
const Recharge = React.lazy(() => import('../pages/Authenticated/Recharge'));
const CreditCard = React.lazy(() => import("../pages/Authenticated/CreditCard"));
const CreditCard1 = React.lazy(() => import("../pages/Authenticated/CreditCard/components/creditCard1"));
const CreditCard2 = React.lazy(() => import("../pages/Authenticated/CreditCard/components/creditCard2"));
const Fastag = React.lazy(() => import("../pages/Authenticated/Fastag"));
const PaymentGateway = React.lazy(() => import("../pages/Authenticated/PaymentGateway"));
const InsuranceScreen = React.lazy(() => import("../pages/Authenticated/Insurance"));
const TravelScreen = React.lazy(() => import("../pages/Authenticated/Travel"));
const AepsScreen = React.lazy(() => import("../pages/Authenticated/AEPS"));
const DeMudraScreen = React.lazy(() => import("../pages/Authenticated/DeMudra"));
const LICScreen = React.lazy(() => import("../pages/Authenticated/LIC"));
const SMSCollect = React.lazy(() => import("../pages/Authenticated/SMSCollect"));
const AadharPayScreen = React.lazy(() => import("../pages/Authenticated/AadharPay"));
const QrPayScreen = React.lazy(() => import("../pages/Authenticated/QRPAY"));
const CashCollection = React.lazy(() => import("../pages/Authenticated/CashCollection"));
const BillPayScreen = React.lazy(() => import("../pages/Authenticated/BillPay"));
const PanCardScreen = React.lazy(() => import("../pages/Authenticated/PanCard"));
const MicroATM = React.lazy(() => import("../pages/Authenticated/MATM"));
const NSDLPlan = React.lazy(() => import("../pages/Authenticated/NSDLPlan"));
const Payout = React.lazy(() => import("../pages/Authenticated/Payout"));
const RentBharo = React.lazy(() => import("../pages/Authenticated/RentBharo"));
const BankSaathi = React.lazy(() => import("../pages/Authenticated/BankSaathi"));
const SmartCollect = React.lazy(() => import("../pages/Authenticated/SmartCollect"));
const VGC = React.lazy(() => import("../pages/Authenticated/VGC"));
const PPIDMT = React.lazy(() => import("../pages/Authenticated/PPIDMT"));




const DYNAMIC_ROUTES = [

    {
        id: 38,
        title: "Mudra Remit",
        users: ["retailer"],
        path: '/moneyTransfer',
        prod_code: "DMT",
        element: <MoneyTransfer />
    },
    {
        id: 39,
        title: "Recharge",
        users: ["retailer", "distributor"],
        path: '/recharge',
        prod_code: 'RECHARGE',
        element: <Recharge />
    },
    {
        id: 40,
        title: "Credit Card",
        users: ["retailer"],
        prod_code: "CREDITCARD",
        path: '/creditCard',
        element: <CreditCard />
    },

    {
        id: 41,
        title: "Fastag2",
        users: ["retailer"],
        path: '/fastag',
        prod_code: "FASTAG2",
        element: <Fastag />
    },
    {
        id: 42,
        title: "PG",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/paymentGateway',
        prod_code: "PG",
        element: <PaymentGateway />
    },

    {
        id: 43,
        title: "Insurance",
        users: ["retailer"],
        path: '/insurance',
        prod_code: "INSURANCE",
        element: <InsuranceScreen />
    },
    {
        id: 44,
        title: "Travel",
        users: ["retailer"],
        path: '/travel',
        prod_code: "TRAVEL",
        element: <TravelScreen />
    },
    {
        id: 45,
        title: "AEPS",
        users: ["retailer"],
        path: '/aeps',
        prod_code: "AEPS",
        element: <AepsScreen />
    }
    ,
    {
        id: 46,
        title: "दे Mudra",
        users: ["retailer"],
        path: '/de_mudra',
        prod_code: "MOVETONETWORK",
        element: <DeMudraScreen />
    },
    {
        id: 47,
        title: "LIC",
        users: ["retailer"],
        path: '/lic',
        prod_code: "LIC",
        element: <LICScreen />
    },
    {
        id: 48,
        title: "SMS Collect",
        users: ["retailer"],
        path: '/sms_collect',
        prod_code: "SMSCOLLECT",
        element: <SMSCollect />
    },

    {
        id: 49,
        title: "AADHAARPAY",
        users: ["retailer"],
        path: '/aadhar_pay',
        prod_code: "AADHAARPAY",
        element: <AadharPayScreen />
    },
    {
        id: 50,
        title: "QRPAY",
        users: ["retailer"],
        path: '/qr_pay',
        prod_code: "QRPAY",
        element: <QrPayScreen />
    },


    {
        id: 51,
        title: "Cash Collection",
        users: ["retailer"],
        path: '/cash_collection',
        prod_code: "CMS",
        element: <CashCollection />
    },


    {
        id: 52,
        title: "Bill Pay",
        users: ["retailer"],
        path: '/bill_pay',
        prod_code: "BILLPAY_BB",
        element: <BillPayScreen />
    },
    {
        id: 53,
        title: "Pan Card",
        users: ["retailer"],
        path: '/pan_card',
        prod_code: "PANCARD",
        element: <PanCardScreen />
    },


    {
        id: 54,
        title: "Micro ATM",
        users: ["retailer"],
        path: '/micro_atm',
        prod_code: "MATM",
        element: <MicroATM />
    },


    {
        id: 55,
        title: "Credit Card",
        users: ["retailer"],
        path: '/creditCard1',
        prod_code: "CREDITCARD",
        element: <CreditCard1 />
    },
    {
        id: 56,
        title: "Credit Card",
        users: ["retailer"],
        path: '/creditCard2',
        prod_code: "CREDITCARD",
        element: <CreditCard2 />
    },


    {
        id: 57,
        title: "NSDL PAN",
        users: ["retailer"],
        path: '/nsdl_plan',
        prod_code: "NSDL_PANCARD",
        element: <NSDLPlan />
    },
    {
        id: 58,
        title: "Payout",
        users: ["partner", "retailer", "distributor", "superdistributor", "subsuperdistributor"],
        path: '/payout',
        prod_code: "PAYOUT",
        element: <Payout />
    },


    {
        id: 59,
        title: "Smart Collect",
        users: ["retailer"],
        prod_code: "SMARTCOLLECT",
        path: '/smart_collect',
        element: <SmartCollect />
    },

    {
        id: 60,
        title: "Rent Bharo",
        users: ["retailer"],
        prod_code: "RENTPAY",
        path: '/rent_bharo',
        element: <RentBharo />
    },
    {
        id: 61,
        title: "Bank Saathi",
        users: ["retailer"],
        prod_code: "BANKSATHI",
        path: "/bank_saathi",
        element: <BankSaathi />
    },
    {
        id: 62,
        title: "Wallet Load",
        users: ["retailer"],
        prod_code: "PG_WALLET",
        path: "/pg_wallet",
        element: <PGWallet />
    },
    {
        id: 62,
        title: "Mudra Rashi",
        users: ["retailer"],
        prod_code: "MUDRARASHI",
        path: "/mudrarashi",
        element: <MudraRashi />
    },
    {
        id: 63,
        title: "VGC",
        users: ["retailer"],
        prod_code: "VGC",
        path: "/vgc",
        element: <VGC />
    },

    {
        id: 63,
        title: "PPI DMT",
        users: ["retailer"],
        prod_code: "PPI_DMT",
        path: "/ppi_dmt",
        element: <PPIDMT />
    },
    



]


export default DYNAMIC_ROUTES;